// Copyright © 2020 The Things Network Foundation, The Things Industries B.V.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import React from 'react'

import PropTypes from '@ttn-lw/lib/prop-types'
import { getDeviceId } from '@ttn-lw/lib/selectors/id'

import UplinkEvent from '../device/event-types/uplink-event'

const DeviceUplinkEvent = props => {
  const { event, widget } = props
  const deviceId = getDeviceId(event.identifiers[0])

  return <UplinkEvent event={event} deviceId={deviceId} widget={widget} />
}

DeviceUplinkEvent.propTypes = {
  event: PropTypes.event.isRequired,
  widget: PropTypes.bool,
}

DeviceUplinkEvent.defaultProps = {
  widget: false,
}

export default DeviceUplinkEvent
